(function() {
  var DEBUG = /[?&]relaydebug=1/.test(window.location.search);
  function log() {
    if (!DEBUG) return;
    var args = Array.prototype.slice.call(arguments);
    console.log.apply(console, ["[relay]"].concat(args));
    try {
      var line = (/* @__PURE__ */ new Date()).toISOString().slice(11, 19) + " " + args.map(function(a) {
        return typeof a === "string" ? a : JSON.stringify(a);
      }).join(" ");
      localStorage.setItem("relayLog", ((localStorage.getItem("relayLog") || "") + line + "\n").slice(-2e4));
    } catch (e) {
    }
  }
  if (DEBUG && window.fetch) {
    window.__relay = { note: "submit the form, then read this object again" };
    var nativeFetch = window.fetch;
    window.fetch = function(input) {
      var url = typeof input === "string" ? input : input && input.url || "";
      var res = nativeFetch.apply(this, arguments);
      if (url.indexOf("forms.shopifyapps.com") !== -1 && url.indexOf("submission") !== -1) {
        res.then(function(r) {
          r.clone().text().then(function(body) {
            window.__relay = { status: r.status, url, body: body.slice(0, 2e3) };
            log("APP RESPONDED", r.status, body.slice(0, 600));
          });
        }, function(err) {
          window.__relay = { status: "network error", url, body: String(err) };
          log("APP POST FAILED", String(err));
        });
      }
      return res;
    };
  }
  function leadsRoots(formId) {
    return document.querySelectorAll(
      '.quote-modal__leads[data-leads-form-id="' + formId + '"]'
    );
  }
  function leadsHost(formId) {
    var roots = leadsRoots(formId);
    for (var i = 0; i < roots.length; i++) {
      var h = roots[i].querySelector("shopify-forms-embed, shopify-forms-embed-dev");
      if (h) return h;
    }
    return null;
  }
  function rootsUnder(start) {
    var roots = start ? [start] : [];
    for (var i = 0; i < roots.length; i++) {
      Array.prototype.forEach.call(roots[i].querySelectorAll("*"), function(node) {
        if (node.shadowRoot && roots.indexOf(node.shadowRoot) === -1) {
          roots.push(node.shadowRoot);
        }
      });
    }
    return roots;
  }
  function leadsForm(formId) {
    var host = leadsHost(formId);
    if (host && host.shadowRoot) {
      var shadowRoots = rootsUnder(host.shadowRoot);
      for (var j = 0; j < shadowRoots.length; j++) {
        var inShadow = shadowRoots[j].querySelector("form");
        if (inShadow) return inShadow;
      }
    }
    var roots = leadsRoots(formId);
    for (var i = 0; i < roots.length; i++) {
      var f = roots[i].querySelector("form");
      if (f) return f;
    }
    return null;
  }
  function whenLeadsForm(formId, cb) {
    var tries = 0;
    (function poll() {
      var lf = leadsForm(formId);
      if (lf || tries >= 80) {
        log("form", formId, lf ? "found after " + tries * 100 + "ms" : "NEVER MOUNTED");
        cb(lf);
        return;
      }
      tries++;
      setTimeout(poll, 100);
    })();
  }
  function setValue(el, val) {
    if (el.type === "checkbox" || el.type === "radio") {
      var want = el.type === "checkbox" ? !!val : squash(el.value) === squash(val) || squash(hayOf(el)).indexOf(squash(val)) !== -1;
      if (want !== el.checked) el.click();
      ["input", "change"].forEach(function(type) {
        el.dispatchEvent(new Event(type, { bubbles: true }));
      });
      return;
    }
    if (el.tagName === "SELECT") {
      var want = squash(val);
      var hit = Array.prototype.filter.call(el.options, function(o) {
        return squash(o.value) === want || squash(o.textContent) === want;
      })[0];
      if (!hit) {
        hit = Array.prototype.filter.call(el.options, function(o) {
          return o.value && (squash(o.textContent).indexOf(want) !== -1 || want.indexOf(squash(o.textContent)) !== -1);
        })[0];
      }
      if (!hit) return;
      el.value = hit.value;
      ["input", "change", "blur"].forEach(function(type) {
        el.dispatchEvent(new Event(type, { bubbles: true }));
      });
      return;
    }
    var proto = el.tagName === "TEXTAREA" ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype;
    var desc = Object.getOwnPropertyDescriptor(proto, "value");
    if (desc && desc.set) {
      desc.set.call(el, val);
    } else {
      el.value = val;
    }
    ["input", "change", "blur"].forEach(function(type) {
      el.dispatchEvent(new Event(type, { bubbles: true }));
    });
  }
  function hayOf(el) {
    var label = el.labels && el.labels[0] ? el.labels[0].textContent : "";
    return [
      el.name,
      el.id,
      el.type,
      el.placeholder,
      el.autocomplete,
      el.getAttribute("aria-label") || "",
      label
    ].join(" ");
  }
  function squash(text) {
    return String(text).toLowerCase().replace(/[^a-z0-9]/g, "");
  }
  function choiceGroups(lf) {
    var groups = {};
    Array.prototype.forEach.call(lf.querySelectorAll('input[type="radio"], input[type="checkbox"]'), function(r) {
      if (r.type !== "radio" && r.type !== "checkbox") return;
      var key = r.type + ":" + (r.name || r.id);
      (groups[key] = groups[key] || []).push(r);
    });
    return Object.keys(groups).map(function(k) {
      return groups[k];
    }).filter(function(g) {
      return g[0].type === "radio" || g.length > 1;
    });
  }
  function groupQuestion(radios) {
    var box = radios[0].closest ? radios[0].closest('fieldset, [role="radiogroup"], [role="group"]') : null;
    if (box) {
      var named = box.getAttribute("aria-labelledby");
      var root = box.getRootNode ? box.getRootNode() : document;
      var head = named && root.getElementById ? root.getElementById(named) : null;
      var legend = box.querySelector("legend");
      return (head ? head.textContent : "") + " " + (legend ? legend.textContent : "") + " " + (box.getAttribute("aria-label") || "");
    }
    var parent = radios[0].parentElement;
    while (parent && parent.contains && radios.some(function(r) {
      return !parent.contains(r);
    })) parent = parent.parentElement;
    return parent ? parent.textContent || "" : "";
  }
  function pickRadio(radios, val) {
    var want = squash(val);
    var opt = function(r) {
      return squash((r.labels && r.labels[0] ? r.labels[0].textContent : "") || r.value);
    };
    var hit = radios.filter(function(r) {
      return opt(r) === want || squash(r.value) === want;
    })[0] || radios.filter(function(r) {
      var o = opt(r);
      return o && (want.indexOf(o) !== -1 || o.indexOf(want) !== -1);
    })[0];
    if (!hit) return false;
    if (!hit.checked) hit.click();
    ["input", "change"].forEach(function(type) {
      hit.dispatchEvent(new Event(type, { bubbles: true }));
    });
    return { exact: opt(hit) === want || squash(hit.value) === want };
  }
  function fillLeads(lf, data) {
    var fields = Array.prototype.filter.call(
      lf.querySelectorAll("input, textarea, select"),
      function(el) {
        return el.type !== "hidden" && el.type !== "submit" && el.type !== "checkbox" && el.type !== "radio";
      }
    );
    var groups = choiceGroups(lf);
    var inGroup = function(el) {
      return groups.some(function(g) {
        return g.indexOf(el) !== -1;
      });
    };
    var requiredChecks = Array.prototype.filter.call(
      lf.querySelectorAll('input[type="checkbox"]'),
      function(el) {
        return (el.required || el.getAttribute("aria-required") === "true") && !inGroup(el);
      }
    );
    function take(match) {
      for (var i = 0; i < fields.length; i++) {
        if (match(hayOf(fields[i]))) return fields.splice(i, 1)[0];
      }
      return null;
    }
    function byPattern(re) {
      return take(function(hay) {
        return re.test(hay);
      });
    }
    function byLabel(label) {
      var want = squash(label);
      if (!want) return null;
      return take(function(hay) {
        return squash(hay).indexOf(want) !== -1;
      });
    }
    [
      [/email/i, data.email],
      [/phone|tel|mobile|number/i, data.phone],
      [/name/i, data.name]
    ].forEach(function(pair) {
      var el = byPattern(pair[0]);
      if (el) setValue(el, pair[1]);
    });
    var message = byPattern(/message|comment|body|note|enquir|inquir/i);
    var spare = [];
    (data.extra || []).forEach(function(pair) {
      var el = byLabel(pair[0]);
      if (el) {
        setValue(el, pair[1]);
        log("matched", pair[0], "=", pair[1]);
        return;
      }
      var want = squash(pair[0]);
      for (var i = 0; want && i < groups.length; i++) {
        var picked = squash(groupQuestion(groups[i])).indexOf(want) !== -1 && pickRadio(groups[i], pair[1]);
        if (picked) {
          groups.splice(i, 1);
          if (!picked.exact) spare.push(pair[0] + ": " + pair[1]);
          log("matched choice", pair[0], "=", pair[1]);
          return;
        }
      }
      spare.push(pair[0] + ": " + pair[1]);
      log("NO FIELD", pair[0], "=", pair[1]);
    });
    if (message) {
      setValue(message, data.extra ? spare.join(String.fromCharCode(10)) : data.body);
    }
    requiredChecks.forEach(function(el) {
      setValue(el, true);
    });
    if (DEBUG) {
      log("after fill:", Array.prototype.map.call(
        lf.querySelectorAll("input, textarea, select"),
        function(el) {
          return (hayOf(el).trim().split(/\s+/)[0] || el.type) + "=" + JSON.stringify(el.type === "checkbox" ? el.checked : el.value);
        }
      ).join("  "));
    }
  }
  var appAccepted = false;
  if (window.fetch) {
    var plainFetch = window.fetch;
    window.fetch = function(input) {
      var url = typeof input === "string" ? input : input && input.url || "";
      var res = plainFetch.apply(this, arguments);
      if (url.indexOf("forms.shopifyapps.com") !== -1 && url.indexOf("submission") !== -1) {
        res.then(function(r) {
          if (r.ok) appAccepted = true;
        }, function() {
        });
      }
      return res;
    };
  }
  var CONFIRM_WAIT_MS = 3e4;
  function submitLeads(formId, data, onDone, onFail) {
    whenLeadsForm(formId, function(lf) {
      if (!lf) {
        log("app form never mounted");
        onFail();
        return;
      }
      fillLeads(lf, data);
      var settled = false, poll = null, timer = null;
      function settle(fn, why) {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        clearInterval(poll);
        log(why);
        fn();
      }
      poll = setInterval(function() {
        if (appAccepted || !leadsForm(formId)) settle(onDone, "STORED in Shopify Forms");
      }, 250);
      timer = setTimeout(function() {
        settle(onFail, "NOT CONFIRMED after " + CONFIRM_WAIT_MS / 1e3 + "s — sending the theme form natively instead");
      }, CONFIRM_WAIT_MS);
      var go = lf.querySelector('button[type="submit"]') || lf.querySelector('input[type="submit"]') || lf.querySelector("button");
      log("submitting app form via", go ? "button: " + (go.textContent || "").trim() : "requestSubmit");
      if (go) go.click();
      else if (lf.requestSubmit) lf.requestSubmit();
      else settle(onFail, "NO SUBMIT CONTROL FOUND");
    });
  }
  var PARTNER_LABELS = {
    "Partner Type": "I want to become a",
    "Company Name": "Company / Business Name",
    "Tax Number": "GST Number",
    "Work Photos Link": "Work Photos / Portfolio Link"
  };
  function collectPartner(form) {
    var out = { name: "", email: "", phone: "", extra: [] };
    var prefixEl = document.getElementById("whs-phone-prefix");
    var prefix = prefixEl ? prefixEl.textContent.trim() : "";
    function withPrefix(number) {
      if (!prefix || number.charAt(0) === "+") return number;
      var bare = number.replace(/[^0-9]/g, "");
      var code = prefix.replace(/[^0-9]/g, "");
      if (code && bare.indexOf(code) === 0) return "+" + bare;
      return prefix + " " + number;
    }
    Array.prototype.forEach.call(form.elements, function(el) {
      if (!el.name || el.disabled) return;
      if (el.closest && el.closest(".whs__conditional--hidden")) return;
      if ((el.type === "radio" || el.type === "checkbox") && !el.checked) return;
      var v = (el.value || "").trim();
      if (!v) return;
      var label = el.name.replace(/^contact\[/, "").replace(/\]$/, "");
      if (label === "tags" || label === "form_type" || label === "utf8") return;
      label = label.replace(/_intl$/, "");
      if (label === "email") {
        out.email = v;
        return;
      }
      if (label === "Full Name") {
        out.name = v;
        return;
      }
      if (label === "Mobile") {
        out.phone = withPrefix(v);
        return;
      }
      if (label === "WhatsApp") {
        v = withPrefix(v);
      }
      if (label === "Partnership Details") {
        var type = out.extra.filter(function(p) {
          return p[0] === PARTNER_LABELS["Partner Type"];
        })[0];
        if (type) {
          type[1] += " — " + v;
          return;
        }
      }
      out.extra.push([PARTNER_LABELS[label] || label, v]);
    });
    [
      ["WhatsApp", out.phone || "Not provided"],
      ["GST Number", "Not provided"],
      ["Annual Turnover", "Not provided"]
    ].forEach(function(req) {
      var has = out.extra.some(function(p) {
        return p[0] === req[0];
      });
      if (!has) out.extra.push(req);
    });
    return out;
  }
  var RULES = {
    "Full Name": function(v) {
      if (!v) return "Please enter your full name.";
      if (!/^[\p{L}][\p{L} .'-]*$/u.test(v) || (v.match(new RegExp("\\p{L}", "gu")) || []).length < 2) return "Use letters only (e.g. Rahul Sharma).";
    },
    "Company Name": function(v) {
      if (!v) return "Please enter your company or business name.";
      if (v.length < 2 || !new RegExp("\\p{L}", "u").test(v)) return "Please enter a valid business name.";
    },
    "Country": function(v) {
      if (!v) return "Please select your country.";
    },
    "Mobile": function(v, ctx) {
      return phoneError(v, ctx, true);
    },
    "WhatsApp": function(v, ctx) {
      return v ? phoneError(v, ctx, false) : "";
    },
    "email": function(v) {
      if (!v) return "Please enter your email address.";
      if (!/^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(v)) return "Please enter a valid email (e.g. you@company.com).";
    },
    "City": function(v) {
      if (!v) return "Please enter your city.";
      if (!/^[\p{L}][\p{L} .'-]*$/u.test(v)) return "Please enter a valid city name.";
    },
    "State": function(v, ctx) {
      if (ctx.india && !v) return "Please select your state.";
    },
    "Shop Type": function(v) {
      if (!v) return "Please select your shop type.";
    },
    "Years in Business": function(v) {
      if (!v) return "Please select how long you have been in business.";
    },
    "Tax Number": function(v, ctx) {
      if (v && ctx.india && !/^\d{2}[A-Z]{5}\d{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/.test(v.toUpperCase().replace(/\s/g, ""))) {
        return "Enter a valid 15-character GSTIN (e.g. 27AAAAA0000A1Z5), or leave it blank.";
      }
    },
    "Distribution Territory": function(v) {
      if (!v || v.length < 3) return "Please enter the cities / regions you cover.";
    },
    "Dealers Covered": function(v) {
      if (!v) return "Please select how many dealers you cover.";
    },
    "Warehouse Available": function(v) {
      if (!v) return "Please tell us if you have a warehouse.";
    },
    "Contractor Type": function(v) {
      if (!v) return "Please select your contractor type.";
    },
    "Experience": function(v) {
      if (!v) return "Please select your years of experience.";
    },
    "Work Photos Link": function(v) {
      if (v && !/^https?:\/\/[^\s.]+\.[^\s]{2,}/i.test(v)) return "Please enter a full link starting with https://";
    },
    "Partnership Details": function(v) {
      if (!v || v.length < 10) return "Please tell us a little about how you would like to partner (at least 10 characters).";
    }
  };
  function phoneError(v, ctx, required) {
    var d = String(v || "").replace(/\D/g, "");
    if (!d) return required ? "Please enter your mobile number." : "";
    if (ctx.india) {
      if (d.length === 12 && d.indexOf("91") === 0) d = d.slice(2);
      else if (d.length === 11 && d.charAt(0) === "0") d = d.slice(1);
      if (!/^[6-9]\d{9}$/.test(d)) return "Enter a valid 10-digit Indian mobile number.";
    } else if (d.length < 6 || d.length > 15) {
      return "Enter a valid phone number (6–15 digits).";
    }
    return "";
  }
  function fieldName(el) {
    return (el.name || "").replace(/^contact\[/, "").replace(/\]$/, "");
  }
  function isLive(el) {
    return !el.disabled && !(el.closest && el.closest(".whs__conditional--hidden"));
  }
  function errorBox(el) {
    var field = el.closest(".whs__field") || el.parentNode;
    var box = field.querySelector(".whs__field-error");
    if (!box) {
      box = document.createElement("p");
      box.className = "whs__field-error";
      box.id = (el.id || "whs-" + fieldName(el).replace(/\W+/g, "-").toLowerCase()) + "-error";
      box.setAttribute("aria-live", "polite");
      field.appendChild(box);
    }
    return box;
  }
  function showError(el, msg) {
    var box = errorBox(el);
    box.textContent = msg || "";
    box.hidden = !msg;
    el.classList.toggle("whs__input--invalid", !!msg);
    if (msg) {
      el.setAttribute("aria-invalid", "true");
      el.setAttribute("aria-describedby", box.id);
    } else {
      el.removeAttribute("aria-invalid");
    }
  }
  function context(form) {
    var c = form.querySelector('[name="contact[Country]"]');
    return { india: !c || c.value === "India" || c.value === "" };
  }
  function checkField(form, el) {
    var rule = RULES[fieldName(el)];
    if (!rule || !isLive(el)) return "";
    var msg = rule((el.value || "").trim(), context(form)) || "";
    showError(el, msg);
    return msg;
  }
  function checkType(form) {
    var picked = form.querySelector('[name="contact[Partner Type]"]:checked');
    var group = form.querySelector(".whs__type-selector");
    if (!group) return "";
    var box = group.parentNode.querySelector(".whs__type-error");
    if (!box) {
      box = document.createElement("p");
      box.className = "whs__field-error whs__type-error";
      box.setAttribute("aria-live", "polite");
      group.parentNode.insertBefore(box, group.nextSibling);
    }
    var msg = picked ? "" : "Please choose how you want to partner with us.";
    box.textContent = msg;
    box.hidden = !msg;
    return msg;
  }
  function validatePartner(form) {
    var first = checkType(form) ? form.querySelector('[name="contact[Partner Type]"]') : null;
    Array.prototype.forEach.call(form.querySelectorAll("input, select, textarea"), function(el) {
      if (el.type === "radio" || el.type === "hidden") return;
      if (checkField(form, el) && !first) first = el;
    });
    return first;
  }
  function wireValidation(form) {
    form.noValidate = true;
    form.addEventListener("focusout", function(e) {
      if (e.target && RULES[fieldName(e.target)]) checkField(form, e.target);
    });
    form.addEventListener("input", function(e) {
      if (e.target && e.target.getAttribute("aria-invalid") === "true") checkField(form, e.target);
    });
    form.addEventListener("change", function(e) {
      if (!e.target) return;
      if (e.target.name === "contact[Partner Type]") checkType(form);
      else if (e.target.name === "contact[Country]") {
        ["Mobile", "WhatsApp", "State", "Tax Number"].forEach(function(n) {
          var el = form.querySelector('[name="contact[' + n + ']"]');
          if (el && el.value) checkField(form, el);
        });
      } else if (RULES[fieldName(e.target)]) checkField(form, e.target);
    });
  }
  function wirePartner(form) {
    if (form.dataset.partnerRelay) return;
    form.dataset.partnerRelay = "1";
    wireValidation(form);
    var formId = form.dataset.leadsFormId;
    var submitBtn = form.querySelector(".whs__submit");
    function showSuccess() {
      form.innerHTML = [
        '<div class="whs__success" role="alert">',
        '<i class="fa-solid fa-circle-check" aria-hidden="true"></i>',
        "<div>",
        "<h3>Application Received!</h3>",
        "<p>Thank you for your interest in partnering with StarShield Paints. Our team will review your details and contact you within 24 hours.</p>",
        "</div>",
        "</div>"
      ].join("");
    }
    function sendNatively() {
      form.dataset.native = "1";
      if (submitBtn) submitBtn.disabled = false;
      if (form.requestSubmit) form.requestSubmit();
      else HTMLFormElement.prototype.submit.call(form);
    }
    form.addEventListener("submit", function(e) {
      if (form.dataset.native) {
        log("native submit — handed to Shopify (captcha + /contact)");
        return;
      }
      e.preventDefault();
      var bad = validatePartner(form);
      if (bad) {
        log("validation failed on", fieldName(bad) || bad.name);
        if (bad.scrollIntoView) bad.scrollIntoView({ behavior: "smooth", block: "center" });
        if (bad.focus) bad.focus({ preventScroll: true });
        return;
      }
      if (!formId) {
        sendNatively();
        return;
      }
      if (form.dataset.relaying) return;
      form.dataset.relaying = "1";
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.innerHTML = '<i class="fa-solid fa-spinner fa-spin" aria-hidden="true"></i> Submitting...';
      }
      submitLeads(formId, collectPartner(form), showSuccess, sendNatively);
    });
  }
  function init() {
    document.querySelectorAll("form.whs__contact-form").forEach(wirePartner);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
